/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
 /* tslint:disable */

import * as import0 from './cart.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/render/api';
import * as import3 from '@angular/core/src/linker/element';
import * as import4 from '@angular/core/src/linker/view_utils';
import * as import5 from '@angular/core/src/di/injector';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/change_detection';
import * as import8 from '../shared/intl.service';
import * as import9 from '../shared/config.service';
import * as import10 from '../shared/content.service';
import * as import11 from '@angular/core/src/linker/element_ref';
import * as import12 from '../shared/utils.service';
import * as import13 from './cart.service';
import * as import14 from '@angular/router/src/router_state';
import * as import15 from '@angular/router/src/router';
import * as import16 from '@angular/core/src/metadata/view';
import * as import17 from '@angular/core/src/linker/component_factory';
import * as import18 from '../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import19 from '../shared/intl.pipe';
import * as import20 from '../shared/number-format.pipe';
import * as import21 from '@angular/core/src/linker/template_ref';
import * as import22 from '@angular/common/src/directives/ng_if';
import * as import23 from '@angular/core/src/security';
import * as import24 from '../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import25 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import26 from '@angular/common/src/directives/ng_for';
import * as import27 from '../../../node_modules/@angular/forms/src/directives/select_control_value_accessor.ngfactory';
import * as import28 from '../../../node_modules/@angular/forms/src/directives/ng_model.ngfactory';
import * as import29 from '../../../node_modules/@angular/forms/src/directives/ng_control_status.ngfactory';
import * as import30 from '@angular/forms/src/directives/select_control_value_accessor';
import * as import31 from '@angular/forms/src/directives/control_value_accessor';
import * as import32 from '@angular/forms/src/directives/ng_model';
import * as import33 from '@angular/forms/src/directives/ng_control';
import * as import34 from '@angular/forms/src/directives/ng_control_status';
import * as import35 from '../../../node_modules/@angular/forms/src/directives/select_multiple_control_value_accessor.ngfactory';
import * as import36 from '@angular/forms/src/directives/select_multiple_control_value_accessor';
import * as import37 from './payment-paypal-express-checkout.component.ngfactory';
import * as import38 from './payment-paypal-express-checkout.component';
export class Wrapper_CartComponent {
  context:import0.CartComponent;
  changed:boolean;
  constructor(p0:any,p1:any,p2:any,p3:any,p4:any,p5:any,p6:any,p7:any) {
    this.changed = false;
    this.context = new import0.CartComponent(p0,p1,p2,p3,p4,p5,p6,p7);
  }
  detectChangesInInputProps(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this.changed;
    this.changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  detectChangesInHostProps(view:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
}
var renderType_CartComponent_Host:import2.RenderComponentType = (null as any);
class _View_CartComponent_Host0 extends import1.AppView<any> {
  _el_0:any;
  /*private*/ _appEl_0:import3.AppElement;
  _CartComponent_0_4:Wrapper_CartComponent;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_CartComponent_Host0,renderType_CartComponent_Host,import6.ViewType.HOST,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.selectOrCreateRenderHostElement(this.renderer,'ng-component',import4.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this._appEl_0 = new import3.AppElement(0,(null as any),this,this._el_0);
    var compView_0:any = viewFactory_CartComponent0(this.viewUtils,this.injector(0),this._appEl_0);
    this._CartComponent_0_4 = new Wrapper_CartComponent(this.parentInjector.get(import8.IntlService),this.parentInjector.get(import9.ConfigService),this.parentInjector.get(import10.ContentService),new import11.ElementRef(this._el_0),this.parentInjector.get(import12.UtilsService),this.parentInjector.get(import13.CartService),this.parentInjector.get(import14.ActivatedRoute),this.parentInjector.get(import15.Router));
    this._appEl_0.initComponent(this._CartComponent_0_4.context,([] as any[]),compView_0);
    compView_0.create(this._CartComponent_0_4.context,this.projectableNodes,(null as any));
    this.init(([] as any[]).concat([this._el_0]),[this._el_0],([] as any[]),([] as any[]));
    return this._appEl_0;
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.CartComponent) && (0 === requestNodeIndex))) { return this._CartComponent_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._CartComponent_0_4.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    if (!throwOnChange) {
      if ((this.numberOfChecks === 0)) { this._CartComponent_0_4.context.ngAfterContentInit(); }
      this._CartComponent_0_4.context.ngAfterContentChecked();
    }
    this._CartComponent_0_4.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_CartComponent_Host0(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  if ((renderType_CartComponent_Host === (null as any))) { (renderType_CartComponent_Host = viewUtils.createRenderComponentType('',0,import16.ViewEncapsulation.None,([] as any[]),{})); }
  return new _View_CartComponent_Host0(viewUtils,parentInjector,declarationEl);
}
export const CartComponentNgFactory:import17.ComponentFactory<import0.CartComponent> = new import17.ComponentFactory<import0.CartComponent>('ng-component',viewFactory_CartComponent_Host0,import0.CartComponent);
const styles_CartComponent:any[] = ([] as any[]);
var renderType_CartComponent:import2.RenderComponentType = (null as any);
class _View_CartComponent0 extends import1.AppView<import0.CartComponent> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _text_14:any;
  _anchor_15:any;
  /*private*/ _appEl_15:import3.AppElement;
  _TemplateRef_15_5:any;
  _NgIf_15_6:import18.Wrapper_NgIf;
  _text_16:any;
  _anchor_17:any;
  /*private*/ _appEl_17:import3.AppElement;
  _TemplateRef_17_5:any;
  _NgIf_17_6:import18.Wrapper_NgIf;
  _text_18:any;
  _text_19:any;
  _text_20:any;
  _text_21:any;
  _text_22:any;
  _text_23:any;
  _text_24:any;
  _el_25:any;
  _text_26:any;
  _el_27:any;
  _text_28:any;
  _text_29:any;
  _anchor_30:any;
  /*private*/ _appEl_30:import3.AppElement;
  _TemplateRef_30_5:any;
  _NgIf_30_6:import18.Wrapper_NgIf;
  _text_31:any;
  _anchor_32:any;
  /*private*/ _appEl_32:import3.AppElement;
  _TemplateRef_32_5:any;
  _NgIf_32_6:import18.Wrapper_NgIf;
  _text_33:any;
  _text_34:any;
  _anchor_35:any;
  /*private*/ _appEl_35:import3.AppElement;
  _TemplateRef_35_5:any;
  _NgIf_35_6:import18.Wrapper_NgIf;
  _text_36:any;
  _text_37:any;
  _text_38:any;
  _pipe_intl_0:import19.IntlPipe;
  _pipe_numberFormat_1:import20.NumberFormat;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_CartComponent0,renderType_CartComponent,import6.ViewType.COMPONENT,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    const parentRenderNode:any = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
    this._el_0 = import4.createRenderElement(this.renderer,parentRenderNode,'section',new import4.InlineArray2(2,'class','page-title-pull-top page-title parallax3 parallax-fix'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import4.createRenderElement(this.renderer,this._el_0,'div',new import4.InlineArray2(2,'class','opacity-light bg-dark-gray'),(null as any));
    this._text_3 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._text_4 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._text_5 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._el_6 = import4.createRenderElement(this.renderer,parentRenderNode,'section',new import4.InlineArray2(2,'class','page-title page-title-small bg-gray'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n    ',(null as any));
    this._el_8 = import4.createRenderElement(this.renderer,this._el_6,'div',new import4.InlineArray2(2,'class','container'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'\n        ',(null as any));
    this._el_10 = import4.createRenderElement(this.renderer,this._el_8,'div',new import4.InlineArray2(2,'class','row'),(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'\n            ',(null as any));
    this._el_12 = import4.createRenderElement(this.renderer,this._el_10,'div',new import4.InlineArray2(2,'class','col-md-8 col-sm-12'),(null as any));
    this._text_13 = this.renderer.createText(this._el_12,'\n                ',(null as any));
    this._text_14 = this.renderer.createText(this._el_12,'\n                ',(null as any));
    this._anchor_15 = this.renderer.createTemplateAnchor(this._el_12,(null as any));
    this._appEl_15 = new import3.AppElement(15,12,this,this._anchor_15);
    this._TemplateRef_15_5 = new import21.TemplateRef_(this._appEl_15,viewFactory_CartComponent1);
    this._NgIf_15_6 = new import18.Wrapper_NgIf(this._appEl_15.vcRef,this._TemplateRef_15_5);
    this._text_16 = this.renderer.createText(this._el_12,'\n                ',(null as any));
    this._anchor_17 = this.renderer.createTemplateAnchor(this._el_12,(null as any));
    this._appEl_17 = new import3.AppElement(17,12,this,this._anchor_17);
    this._TemplateRef_17_5 = new import21.TemplateRef_(this._appEl_17,viewFactory_CartComponent2);
    this._NgIf_17_6 = new import18.Wrapper_NgIf(this._appEl_17.vcRef,this._TemplateRef_17_5);
    this._text_18 = this.renderer.createText(this._el_12,'\n                ',(null as any));
    this._text_19 = this.renderer.createText(this._el_12,'\n            ',(null as any));
    this._text_20 = this.renderer.createText(this._el_10,'\n        ',(null as any));
    this._text_21 = this.renderer.createText(this._el_8,'\n    ',(null as any));
    this._text_22 = this.renderer.createText(this._el_6,'\n',(null as any));
    this._text_23 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._text_24 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._el_25 = import4.createRenderElement(this.renderer,parentRenderNode,'section',new import4.InlineArray2(2,'class','content-section section-pull-up-less'),(null as any));
    this._text_26 = this.renderer.createText(this._el_25,'\n    ',(null as any));
    this._el_27 = import4.createRenderElement(this.renderer,this._el_25,'div',new import4.InlineArray2(2,'class','container'),(null as any));
    this._text_28 = this.renderer.createText(this._el_27,'\n\n        ',(null as any));
    this._text_29 = this.renderer.createText(this._el_27,'\n        ',(null as any));
    this._anchor_30 = this.renderer.createTemplateAnchor(this._el_27,(null as any));
    this._appEl_30 = new import3.AppElement(30,27,this,this._anchor_30);
    this._TemplateRef_30_5 = new import21.TemplateRef_(this._appEl_30,viewFactory_CartComponent3);
    this._NgIf_30_6 = new import18.Wrapper_NgIf(this._appEl_30.vcRef,this._TemplateRef_30_5);
    this._text_31 = this.renderer.createText(this._el_27,'\n        ',(null as any));
    this._anchor_32 = this.renderer.createTemplateAnchor(this._el_27,(null as any));
    this._appEl_32 = new import3.AppElement(32,27,this,this._anchor_32);
    this._TemplateRef_32_5 = new import21.TemplateRef_(this._appEl_32,viewFactory_CartComponent4);
    this._NgIf_32_6 = new import18.Wrapper_NgIf(this._appEl_32.vcRef,this._TemplateRef_32_5);
    this._text_33 = this.renderer.createText(this._el_27,'\n\n        ',(null as any));
    this._text_34 = this.renderer.createText(this._el_27,'\n        ',(null as any));
    this._anchor_35 = this.renderer.createTemplateAnchor(this._el_27,(null as any));
    this._appEl_35 = new import3.AppElement(35,27,this,this._anchor_35);
    this._TemplateRef_35_5 = new import21.TemplateRef_(this._appEl_35,viewFactory_CartComponent5);
    this._NgIf_35_6 = new import18.Wrapper_NgIf(this._appEl_35.vcRef,this._TemplateRef_35_5);
    this._text_36 = this.renderer.createText(this._el_27,'\n\n    ',(null as any));
    this._text_37 = this.renderer.createText(this._el_25,'\n\n',(null as any));
    this._text_38 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._pipe_intl_0 = new import19.IntlPipe();
    this._pipe_numberFormat_1 = new import20.NumberFormat();
    this.init(([] as any[]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._text_14,
      this._anchor_15,
      this._text_16,
      this._anchor_17,
      this._text_18,
      this._text_19,
      this._text_20,
      this._text_21,
      this._text_22,
      this._text_23,
      this._text_24,
      this._el_25,
      this._text_26,
      this._el_27,
      this._text_28,
      this._text_29,
      this._anchor_30,
      this._text_31,
      this._anchor_32,
      this._text_33,
      this._text_34,
      this._anchor_35,
      this._text_36,
      this._text_37,
      this._text_38
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import21.TemplateRef) && (15 === requestNodeIndex))) { return this._TemplateRef_15_5; }
    if (((token === import22.NgIf) && (15 === requestNodeIndex))) { return this._NgIf_15_6.context; }
    if (((token === import21.TemplateRef) && (17 === requestNodeIndex))) { return this._TemplateRef_17_5; }
    if (((token === import22.NgIf) && (17 === requestNodeIndex))) { return this._NgIf_17_6.context; }
    if (((token === import21.TemplateRef) && (30 === requestNodeIndex))) { return this._TemplateRef_30_5; }
    if (((token === import22.NgIf) && (30 === requestNodeIndex))) { return this._NgIf_30_6.context; }
    if (((token === import21.TemplateRef) && (32 === requestNodeIndex))) { return this._TemplateRef_32_5; }
    if (((token === import22.NgIf) && (32 === requestNodeIndex))) { return this._NgIf_32_6.context; }
    if (((token === import21.TemplateRef) && (35 === requestNodeIndex))) { return this._TemplateRef_35_5; }
    if (((token === import22.NgIf) && (35 === requestNodeIndex))) { return this._NgIf_35_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_15_0_0:boolean = !((this.context.cartService.paymentData == (null as any))? (null as any): this.context.cartService.paymentData.paymentID);
    this._NgIf_15_6.check_ngIf(currVal_15_0_0,throwOnChange,false);
    this._NgIf_15_6.detectChangesInInputProps(this,this._anchor_15,throwOnChange);
    const currVal_17_0_0:any = ((this.context.cartService.paymentData == (null as any))? (null as any): this.context.cartService.paymentData.paymentID);
    this._NgIf_17_6.check_ngIf(currVal_17_0_0,throwOnChange,false);
    this._NgIf_17_6.detectChangesInInputProps(this,this._anchor_17,throwOnChange);
    const currVal_30_0_0:any = ((this.context.cartService.paymentData == (null as any))? (null as any): this.context.cartService.paymentData.paymentID);
    this._NgIf_30_6.check_ngIf(currVal_30_0_0,throwOnChange,false);
    this._NgIf_30_6.detectChangesInInputProps(this,this._anchor_30,throwOnChange);
    const currVal_32_0_0:any = ((this.context.cartService.paymentData == (null as any))? (null as any): this.context.cartService.paymentData.paymentID);
    this._NgIf_32_6.check_ngIf(currVal_32_0_0,throwOnChange,false);
    this._NgIf_32_6.detectChangesInInputProps(this,this._anchor_32,throwOnChange);
    const currVal_35_0_0:boolean = !((this.context.cartService.paymentData == (null as any))? (null as any): this.context.cartService.paymentData.paymentID);
    this._NgIf_35_6.check_ngIf(currVal_35_0_0,throwOnChange,false);
    this._NgIf_35_6.detectChangesInInputProps(this,this._anchor_35,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
export function viewFactory_CartComponent0(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<import0.CartComponent> {
  if ((renderType_CartComponent === (null as any))) { (renderType_CartComponent = viewUtils.createRenderComponentType('',0,import16.ViewEncapsulation.None,styles_CartComponent,{})); }
  return new _View_CartComponent0(viewUtils,parentInjector,declarationEl);
}
class _View_CartComponent1 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  _pipe_intl_0_0:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_CartComponent1,renderType_CartComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_2 = import7.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'h1',new import4.InlineArray2(2,'class','black-text'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_intl_0_0 = import4.pureProxy2((<_View_CartComponent0>this.parent)._pipe_intl_0.transform.bind((<_View_CartComponent0>this.parent)._pipe_intl_0));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import7.ValueUnwrapper();
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_2:any = import4.interpolate(1,'',valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_0,(<_View_CartComponent0>this.parent)._pipe_intl_0.transform)(((this.parent.context.intl.data == (null as any))? (null as any): this.parent.context.intl.data.CART.TITLE),this.parent.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_2,currVal_2))) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_CartComponent1(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_CartComponent1(viewUtils,parentInjector,declarationEl);
}
class _View_CartComponent2 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  _pipe_intl_0_1:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_CartComponent2,renderType_CartComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_2 = import7.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'h1',new import4.InlineArray2(2,'class','black-text'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_intl_0_1 = import4.pureProxy2((<_View_CartComponent0>this.parent)._pipe_intl_0.transform.bind((<_View_CartComponent0>this.parent)._pipe_intl_0));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import7.ValueUnwrapper();
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_2:any = import4.interpolate(1,'',valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_1,(<_View_CartComponent0>this.parent)._pipe_intl_0.transform)(((this.parent.context.intl.data == (null as any))? (null as any): this.parent.context.intl.data.CART.ORDER.TITLE),this.parent.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_2,currVal_2))) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_CartComponent2(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_CartComponent2(viewUtils,parentInjector,declarationEl);
}
class _View_CartComponent3 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _text_6:any;
  _el_7:any;
  _text_8:any;
  _el_9:any;
  _text_10:any;
  _text_11:any;
  _text_12:any;
  _el_13:any;
  _text_14:any;
  _el_15:any;
  _text_16:any;
  _text_17:any;
  _el_18:any;
  _text_19:any;
  _el_20:any;
  _el_21:any;
  _text_22:any;
  _text_23:any;
  _text_24:any;
  _text_25:any;
  /*private*/ _expr_26:any;
  _pipe_intl_0_2:any;
  /*private*/ _expr_28:any;
  _pipe_intl_0_3:any;
  /*private*/ _expr_30:any;
  _pipe_intl_0_4:any;
  /*private*/ _expr_32:any;
  /*private*/ _expr_33:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_CartComponent3,renderType_CartComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_26 = import7.UNINITIALIZED;
    this._expr_28 = import7.UNINITIALIZED;
    this._expr_30 = import7.UNINITIALIZED;
    this._expr_32 = import7.UNINITIALIZED;
    this._expr_33 = import7.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'div',new import4.InlineArray2(2,'class','row'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._el_2 = import4.createRenderElement(this.renderer,this._el_0,'div',new import4.InlineArray2(2,'class','col-md-6 col-sm-6 xs-margin-bottom-five'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,' \n                ',(null as any));
    this._el_4 = import4.createRenderElement(this.renderer,this._el_2,'p',new import4.InlineArray2(2,'class','text-med'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'',(null as any));
    this._text_6 = this.renderer.createText(this._el_2,'\n                ',(null as any));
    this._el_7 = import4.createRenderElement(this.renderer,this._el_2,'p',new import4.InlineArray2(2,'class','text-med'),(null as any));
    this._text_8 = this.renderer.createText(this._el_7,'',(null as any));
    this._el_9 = import4.createRenderElement(this.renderer,this._el_7,'a',new import4.InlineArray2(2,'href','mailto:order@forgottenrecords.com'),(null as any));
    this._text_10 = this.renderer.createText(this._el_9,'order@forgottenrecords.com',(null as any));
    this._text_11 = this.renderer.createText(this._el_2,'\n            ',(null as any));
    this._text_12 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._el_13 = import4.createRenderElement(this.renderer,this._el_0,'div',new import4.InlineArray2(2,'class','col-md-6 col-sm-6'),(null as any));
    this._text_14 = this.renderer.createText(this._el_13,'\n                ',(null as any));
    this._el_15 = import4.createRenderElement(this.renderer,this._el_13,'p',new import4.InlineArray2(2,'class','text-large font-weight-600 text-black margin-three no-margin-top'),(null as any));
    this._text_16 = this.renderer.createText(this._el_15,' ',(null as any));
    this._text_17 = this.renderer.createText(this._el_13,'\n                ',(null as any));
    this._el_18 = import4.createRenderElement(this.renderer,this._el_13,'p',new import4.InlineArray2(2,'class','text-med no-margin'),(null as any));
    this._text_19 = this.renderer.createText(this._el_18,'',(null as any));
    this._el_20 = import4.createRenderElement(this.renderer,this._el_18,'code',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._el_21 = import4.createRenderElement(this.renderer,this._el_20,'a',new import4.InlineArray2(2,'target','_blank'),(null as any));
    this._text_22 = this.renderer.createText(this._el_21,'',(null as any));
    this._text_23 = this.renderer.createText(this._el_18,'\n                ',(null as any));
    this._text_24 = this.renderer.createText(this._el_13,'\n            ',(null as any));
    this._text_25 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this._pipe_intl_0_2 = import4.pureProxy2((<_View_CartComponent0>this.parent)._pipe_intl_0.transform.bind((<_View_CartComponent0>this.parent)._pipe_intl_0));
    this._pipe_intl_0_3 = import4.pureProxy2((<_View_CartComponent0>this.parent)._pipe_intl_0.transform.bind((<_View_CartComponent0>this.parent)._pipe_intl_0));
    this._pipe_intl_0_4 = import4.pureProxy2((<_View_CartComponent0>this.parent)._pipe_intl_0.transform.bind((<_View_CartComponent0>this.parent)._pipe_intl_0));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._text_6,
      this._el_7,
      this._text_8,
      this._el_9,
      this._text_10,
      this._text_11,
      this._text_12,
      this._el_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._text_17,
      this._el_18,
      this._text_19,
      this._el_20,
      this._el_21,
      this._text_22,
      this._text_23,
      this._text_24,
      this._text_25
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import7.ValueUnwrapper();
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_26:any = import4.interpolate(1,'',valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_2,(<_View_CartComponent0>this.parent)._pipe_intl_0.transform)(((this.parent.context.intl.data == (null as any))? (null as any): this.parent.context.intl.data.CART.ORDER.MESSAGE),this.parent.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_26,currVal_26))) {
      this.renderer.setText(this._text_5,currVal_26);
      this._expr_26 = currVal_26;
    }
    valUnwrapper.reset();
    const currVal_28:any = import4.interpolate(1,'',valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_3,(<_View_CartComponent0>this.parent)._pipe_intl_0.transform)(((this.parent.context.intl.data == (null as any))? (null as any): this.parent.context.intl.data.CART.ORDER.QUESTION),this.parent.context.currentLanguage)),' ');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_28,currVal_28))) {
      this.renderer.setText(this._text_8,currVal_28);
      this._expr_28 = currVal_28;
    }
    valUnwrapper.reset();
    const currVal_30:any = import4.interpolate(1,'',valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_4,(<_View_CartComponent0>this.parent)._pipe_intl_0.transform)(((this.parent.context.intl.data == (null as any))? (null as any): this.parent.context.intl.data.CART.ORDER.PAYMENT_ID),this.parent.context.currentLanguage)),': \n                    ');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_30,currVal_30))) {
      this.renderer.setText(this._text_19,currVal_30);
      this._expr_30 = currVal_30;
    }
    const currVal_32:any = import4.interpolate(1,'',this.parent.context.cartService.paymentData.returnUrl,'');
    if (import4.checkBinding(throwOnChange,this._expr_32,currVal_32)) {
      this.renderer.setElementProperty(this._el_21,'href',this.viewUtils.sanitizer.sanitize(import23.SecurityContext.URL,currVal_32));
      this._expr_32 = currVal_32;
    }
    const currVal_33:any = import4.interpolate(1,'',this.parent.context.cartService.paymentData.paymentID,'');
    if (import4.checkBinding(throwOnChange,this._expr_33,currVal_33)) {
      this.renderer.setText(this._text_22,currVal_33);
      this._expr_33 = currVal_33;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_CartComponent3(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_CartComponent3(viewUtils,parentInjector,declarationEl);
}
class _View_CartComponent4 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _text_6:any;
  _text_7:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_CartComponent4,renderType_CartComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'div',new import4.InlineArray2(2,'class','row'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._el_2 = import4.createRenderElement(this.renderer,this._el_0,'div',new import4.InlineArray2(2,'class','learn-more row col-md-12 col-sm-12 center-col text-center'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                ',(null as any));
    this._el_4 = import4.createRenderElement(this.renderer,this._el_2,'a',new import4.InlineArray2(2,'class','pointer highlight-button btn btn-medium button xs-margin-bottom-five'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'Revenir au catalogue',(null as any));
    this._text_6 = this.renderer.createText(this._el_2,'\n            ',(null as any));
    this._text_7 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_4,'click',this.eventHandler(this._handle_click_4_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._text_6,
      this._text_7
    ]
    ,[disposable_0],([] as any[]));
    return (null as any);
  }
  private _handle_click_4_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_4_0:any = ((<any>this.parent.context.router.navigate(['catalogue'],{relativeTo: this.parent.context.route.parent})) !== false);
    return (true && pd_4_0);
  }
}
function viewFactory_CartComponent4(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_CartComponent4(viewUtils,parentInjector,declarationEl);
}
class _View_CartComponent5 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _anchor_2:any;
  /*private*/ _appEl_2:import3.AppElement;
  _TemplateRef_2_5:any;
  _NgIf_2_6:import18.Wrapper_NgIf;
  _text_3:any;
  _anchor_4:any;
  /*private*/ _appEl_4:import3.AppElement;
  _TemplateRef_4_5:any;
  _NgIf_4_6:import18.Wrapper_NgIf;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _anchor_8:any;
  /*private*/ _appEl_8:import3.AppElement;
  _TemplateRef_8_5:any;
  _NgIf_8_6:import18.Wrapper_NgIf;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _text_12:any;
  _text_13:any;
  _text_14:any;
  _anchor_15:any;
  /*private*/ _appEl_15:import3.AppElement;
  _TemplateRef_15_5:any;
  _NgIf_15_6:import18.Wrapper_NgIf;
  _text_16:any;
  /*private*/ _expr_29:any;
  _pipe_intl_0_10:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_CartComponent5,renderType_CartComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_29 = import7.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'div',new import4.InlineArray2(2,'class','row'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._appEl_2 = new import3.AppElement(2,0,this,this._anchor_2);
    this._TemplateRef_2_5 = new import21.TemplateRef_(this._appEl_2,viewFactory_CartComponent6);
    this._NgIf_2_6 = new import18.Wrapper_NgIf(this._appEl_2.vcRef,this._TemplateRef_2_5);
    this._text_3 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._anchor_4 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._appEl_4 = new import3.AppElement(4,0,this,this._anchor_4);
    this._TemplateRef_4_5 = new import21.TemplateRef_(this._appEl_4,viewFactory_CartComponent9);
    this._NgIf_4_6 = new import18.Wrapper_NgIf(this._appEl_4.vcRef,this._TemplateRef_4_5);
    this._text_5 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._el_6 = import4.createRenderElement(this.renderer,this._el_0,'div',new import4.InlineArray2(2,'class','col-sm-12 cupon padding-five border-top border-bottom'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._anchor_8 = this.renderer.createTemplateAnchor(this._el_6,(null as any));
    this._appEl_8 = new import3.AppElement(8,6,this,this._anchor_8);
    this._TemplateRef_8_5 = new import21.TemplateRef_(this._appEl_8,viewFactory_CartComponent10);
    this._NgIf_8_6 = new import18.Wrapper_NgIf(this._appEl_8.vcRef,this._TemplateRef_8_5);
    this._text_9 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._el_10 = import4.createRenderElement(this.renderer,this._el_6,'button',new import4.InlineArray2(2,'class','highlight-button btn btn-very-small no-margin pull-right continue-shopping'),(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'',(null as any));
    this._text_12 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._text_13 = this.renderer.createText(this._el_6,'\n            ',(null as any));
    this._text_14 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._anchor_15 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._appEl_15 = new import3.AppElement(15,0,this,this._anchor_15);
    this._TemplateRef_15_5 = new import21.TemplateRef_(this._appEl_15,viewFactory_CartComponent11);
    this._NgIf_15_6 = new import18.Wrapper_NgIf(this._appEl_15.vcRef,this._TemplateRef_15_5);
    this._text_16 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_10,'click',this.eventHandler(this._handle_click_10_0.bind(this)));
    this._pipe_intl_0_10 = import4.pureProxy2((<_View_CartComponent0>this.parent)._pipe_intl_0.transform.bind((<_View_CartComponent0>this.parent)._pipe_intl_0));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._anchor_2,
      this._text_3,
      this._anchor_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._anchor_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._text_12,
      this._text_13,
      this._text_14,
      this._anchor_15,
      this._text_16
    ]
    ,[disposable_0],([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import21.TemplateRef) && (2 === requestNodeIndex))) { return this._TemplateRef_2_5; }
    if (((token === import22.NgIf) && (2 === requestNodeIndex))) { return this._NgIf_2_6.context; }
    if (((token === import21.TemplateRef) && (4 === requestNodeIndex))) { return this._TemplateRef_4_5; }
    if (((token === import22.NgIf) && (4 === requestNodeIndex))) { return this._NgIf_4_6.context; }
    if (((token === import21.TemplateRef) && (8 === requestNodeIndex))) { return this._TemplateRef_8_5; }
    if (((token === import22.NgIf) && (8 === requestNodeIndex))) { return this._NgIf_8_6.context; }
    if (((token === import21.TemplateRef) && (15 === requestNodeIndex))) { return this._TemplateRef_15_5; }
    if (((token === import22.NgIf) && (15 === requestNodeIndex))) { return this._NgIf_15_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import7.ValueUnwrapper();
    const currVal_2_0_0:any = (this.parent.context.cartService.count() > 0);
    this._NgIf_2_6.check_ngIf(currVal_2_0_0,throwOnChange,false);
    this._NgIf_2_6.detectChangesInInputProps(this,this._anchor_2,throwOnChange);
    const currVal_4_0_0:any = (this.parent.context.cartService.count() == 0);
    this._NgIf_4_6.check_ngIf(currVal_4_0_0,throwOnChange,false);
    this._NgIf_4_6.detectChangesInInputProps(this,this._anchor_4,throwOnChange);
    const currVal_8_0_0:any = (this.parent.context.cartService.count() > 0);
    this._NgIf_8_6.check_ngIf(currVal_8_0_0,throwOnChange,false);
    this._NgIf_8_6.detectChangesInInputProps(this,this._anchor_8,throwOnChange);
    const currVal_15_0_0:any = (this.parent.context.cartService.count() > 0);
    this._NgIf_15_6.check_ngIf(currVal_15_0_0,throwOnChange,false);
    this._NgIf_15_6.detectChangesInInputProps(this,this._anchor_15,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_29:any = import4.interpolate(1,'\n                    ',valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_10,(<_View_CartComponent0>this.parent)._pipe_intl_0.transform)(((this.parent.context.intl.data == (null as any))? (null as any): this.parent.context.intl.data.CART.BACK),this.parent.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_29,currVal_29))) {
      this.renderer.setText(this._text_11,currVal_29);
      this._expr_29 = currVal_29;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_click_10_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_10_0:any = ((<any>this.parent.context.router.navigate(['catalogue'],{relativeTo: this.parent.context.route.parent})) !== false);
    return (true && pd_10_0);
  }
}
function viewFactory_CartComponent5(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_CartComponent5(viewUtils,parentInjector,declarationEl);
}
class _View_CartComponent6 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _text_14:any;
  _el_15:any;
  _text_16:any;
  _text_17:any;
  _el_18:any;
  _text_19:any;
  _text_20:any;
  _el_21:any;
  _text_22:any;
  _text_23:any;
  _text_24:any;
  _el_25:any;
  _text_26:any;
  _anchor_27:any;
  /*private*/ _appEl_27:import3.AppElement;
  _TemplateRef_27_5:any;
  _NgFor_27_6:import24.Wrapper_NgFor;
  _text_28:any;
  _text_29:any;
  _text_30:any;
  /*private*/ _expr_34:any;
  _pipe_intl_0_5:any;
  /*private*/ _expr_36:any;
  _pipe_intl_0_6:any;
  /*private*/ _expr_38:any;
  _pipe_intl_0_7:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_CartComponent6,renderType_CartComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_34 = import7.UNINITIALIZED;
    this._expr_36 = import7.UNINITIALIZED;
    this._expr_38 = import7.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'div',new import4.InlineArray2(2,'class','col-sm-12 shop-cart-table'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_2 = import4.createRenderElement(this.renderer,this._el_0,'table',new import4.InlineArray2(2,'class','table shop-cart text-center'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                    ',(null as any));
    this._el_4 = import4.createRenderElement(this.renderer,this._el_2,'thead',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                        ',(null as any));
    this._el_6 = import4.createRenderElement(this.renderer,this._el_4,'tr',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                            ',(null as any));
    this._el_8 = import4.createRenderElement(this.renderer,this._el_6,'th',new import4.InlineArray2(2,'class','first'),(null as any));
    this._text_9 = this.renderer.createText(this._el_6,'\n                            ',(null as any));
    this._el_10 = import4.createRenderElement(this.renderer,this._el_6,'th',new import4.InlineArray2(2,'class','text-left text-uppercase font-weight-600 letter-spacing-2 text-small black-text'),(null as any));
    this._text_11 = this.renderer.createText(this._el_6,'\n                            ',(null as any));
    this._el_12 = import4.createRenderElement(this.renderer,this._el_6,'th',new import4.InlineArray2(2,'class','text-left text-uppercase font-weight-600 letter-spacing-2 text-small black-text'),(null as any));
    this._text_13 = this.renderer.createText(this._el_12,'',(null as any));
    this._text_14 = this.renderer.createText(this._el_6,'\n                            ',(null as any));
    this._el_15 = import4.createRenderElement(this.renderer,this._el_6,'th',new import4.InlineArray2(2,'class','text-left text-uppercase font-weight-600 letter-spacing-2 text-small black-text'),(null as any));
    this._text_16 = this.renderer.createText(this._el_15,'',(null as any));
    this._text_17 = this.renderer.createText(this._el_6,'\n                            ',(null as any));
    this._el_18 = import4.createRenderElement(this.renderer,this._el_6,'th',new import4.InlineArray2(2,'class','text-left text-uppercase font-weight-600 letter-spacing-2 text-small black-text'),(null as any));
    this._text_19 = this.renderer.createText(this._el_18,'',(null as any));
    this._text_20 = this.renderer.createText(this._el_6,'\n                            ',(null as any));
    this._el_21 = import4.createRenderElement(this.renderer,this._el_6,'th',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_22 = this.renderer.createText(this._el_6,'\n                        ',(null as any));
    this._text_23 = this.renderer.createText(this._el_4,'\n                    ',(null as any));
    this._text_24 = this.renderer.createText(this._el_2,'\n                    ',(null as any));
    this._el_25 = import4.createRenderElement(this.renderer,this._el_2,'tbody',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_26 = this.renderer.createText(this._el_25,'\n                        ',(null as any));
    this._anchor_27 = this.renderer.createTemplateAnchor(this._el_25,(null as any));
    this._appEl_27 = new import3.AppElement(27,25,this,this._anchor_27);
    this._TemplateRef_27_5 = new import21.TemplateRef_(this._appEl_27,viewFactory_CartComponent7);
    this._NgFor_27_6 = new import24.Wrapper_NgFor(this._appEl_27.vcRef,this._TemplateRef_27_5,this.parent.parent.parentInjector.get(import25.IterableDiffers),this.parent.parent.ref);
    this._text_28 = this.renderer.createText(this._el_25,'\n                    ',(null as any));
    this._text_29 = this.renderer.createText(this._el_2,'\n                ',(null as any));
    this._text_30 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._pipe_intl_0_5 = import4.pureProxy2((<_View_CartComponent0>this.parent.parent)._pipe_intl_0.transform.bind((<_View_CartComponent0>this.parent.parent)._pipe_intl_0));
    this._pipe_intl_0_6 = import4.pureProxy2((<_View_CartComponent0>this.parent.parent)._pipe_intl_0.transform.bind((<_View_CartComponent0>this.parent.parent)._pipe_intl_0));
    this._pipe_intl_0_7 = import4.pureProxy2((<_View_CartComponent0>this.parent.parent)._pipe_intl_0.transform.bind((<_View_CartComponent0>this.parent.parent)._pipe_intl_0));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._text_17,
      this._el_18,
      this._text_19,
      this._text_20,
      this._el_21,
      this._text_22,
      this._text_23,
      this._text_24,
      this._el_25,
      this._text_26,
      this._anchor_27,
      this._text_28,
      this._text_29,
      this._text_30
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import21.TemplateRef) && (27 === requestNodeIndex))) { return this._TemplateRef_27_5; }
    if (((token === import26.NgFor) && (27 === requestNodeIndex))) { return this._NgFor_27_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import7.ValueUnwrapper();
    const currVal_27_0_0:any = this.parent.parent.context.cartService.items;
    this._NgFor_27_6.check_ngForOf(currVal_27_0_0,throwOnChange,false);
    this._NgFor_27_6.detectChangesInInputProps(this,this._anchor_27,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_34:any = import4.interpolate(1,'\n                                ',valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_5,(<_View_CartComponent0>this.parent.parent)._pipe_intl_0.transform)(((this.parent.parent.context.intl.data == (null as any))? (null as any): this.parent.parent.context.intl.data.CART.PROPERTY.PRICE),this.parent.parent.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_34,currVal_34))) {
      this.renderer.setText(this._text_13,currVal_34);
      this._expr_34 = currVal_34;
    }
    valUnwrapper.reset();
    const currVal_36:any = import4.interpolate(1,'\n                                ',valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_6,(<_View_CartComponent0>this.parent.parent)._pipe_intl_0.transform)(((this.parent.parent.context.intl.data == (null as any))? (null as any): this.parent.parent.context.intl.data.CART.PROPERTY.QUANTITY),this.parent.parent.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_36,currVal_36))) {
      this.renderer.setText(this._text_16,currVal_36);
      this._expr_36 = currVal_36;
    }
    valUnwrapper.reset();
    const currVal_38:any = import4.interpolate(1,'\n                                ',valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_7,(<_View_CartComponent0>this.parent.parent)._pipe_intl_0.transform)(((this.parent.parent.context.intl.data == (null as any))? (null as any): this.parent.parent.context.intl.data.CART.PROPERTY.SUBTOTAL),this.parent.parent.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_38,currVal_38))) {
      this.renderer.setText(this._text_19,currVal_38);
      this._expr_38 = currVal_38;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_CartComponent6(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_CartComponent6(viewUtils,parentInjector,declarationEl);
}
class _View_CartComponent7 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _text_8:any;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _text_14:any;
  _el_15:any;
  _text_16:any;
  _text_17:any;
  _text_18:any;
  _text_19:any;
  _el_20:any;
  _text_21:any;
  _text_22:any;
  _el_23:any;
  _text_24:any;
  _el_25:any;
  _text_26:any;
  _el_27:any;
  _SelectControlValueAccessor_27_3:import27.Wrapper_SelectControlValueAccessor;
  _NG_VALUE_ACCESSOR_27_4:any[];
  _NgModel_27_5:import28.Wrapper_NgModel;
  _NgControl_27_6:any;
  _NgControlStatus_27_7:import29.Wrapper_NgControlStatus;
  _text_28:any;
  _anchor_29:any;
  /*private*/ _appEl_29:import3.AppElement;
  _TemplateRef_29_5:any;
  _NgFor_29_6:import24.Wrapper_NgFor;
  _text_30:any;
  _text_31:any;
  _text_32:any;
  _text_33:any;
  _el_34:any;
  _text_35:any;
  _text_36:any;
  _el_37:any;
  _text_38:any;
  _el_39:any;
  _el_40:any;
  _text_41:any;
  _text_42:any;
  /*private*/ _expr_51:any;
  /*private*/ _expr_52:any;
  /*private*/ _expr_53:any;
  /*private*/ _expr_54:any;
  _pipe_numberFormat_1_0:any;
  _arr_56:any;
  /*private*/ _expr_57:any;
  _pipe_numberFormat_1_1:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_CartComponent7,renderType_CartComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_51 = import7.UNINITIALIZED;
    this._expr_52 = import7.UNINITIALIZED;
    this._expr_53 = import7.UNINITIALIZED;
    this._expr_54 = import7.UNINITIALIZED;
    this._arr_56 = import4.pureProxy10((p0:any,p1:any,p2:any,p3:any,p4:any,p5:any,p6:any,p7:any,p8:any,p9:any):any[] => {
      return [
        p0,
        p1,
        p2,
        p3,
        p4,
        p5,
        p6,
        p7,
        p8,
        p9
      ]
      ;
    });
    this._expr_57 = import7.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'tr',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this._el_2 = import4.createRenderElement(this.renderer,this._el_0,'td',new import4.InlineArray2(2,'class','product-thumbnail text-left'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                                ',(null as any));
    this._el_4 = import4.createRenderElement(this.renderer,this._el_2,'a',new import4.InlineArray2(2,'class','pointer'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                                    ',(null as any));
    this._el_6 = import4.createRenderElement(this.renderer,this._el_4,'img',new import4.InlineArray2(2,'alt',''),(null as any));
    this._text_7 = this.renderer.createText(this._el_4,'\n                                ',(null as any));
    this._text_8 = this.renderer.createText(this._el_2,'\n                            ',(null as any));
    this._text_9 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this._el_10 = import4.createRenderElement(this.renderer,this._el_0,'td',new import4.InlineArray2(2,'class','text-left'),(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'\n                                ',(null as any));
    this._el_12 = import4.createRenderElement(this.renderer,this._el_10,'a',new import4.InlineArray2(2,'class','pointer'),(null as any));
    this._text_13 = this.renderer.createText(this._el_12,'',(null as any));
    this._text_14 = this.renderer.createText(this._el_10,'\n                                ',(null as any));
    this._el_15 = import4.createRenderElement(this.renderer,this._el_10,'span',new import4.InlineArray2(2,'class','text-uppercase display-block text-small margin-two'),(null as any));
    this._text_16 = this.renderer.createText(this._el_15,'',(null as any));
    this._text_17 = this.renderer.createText(this._el_10,'\n                                ',(null as any));
    this._text_18 = this.renderer.createText(this._el_10,'\n                            ',(null as any));
    this._text_19 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this._el_20 = import4.createRenderElement(this.renderer,this._el_0,'td',new import4.InlineArray2(2,'class','text-left'),(null as any));
    this._text_21 = this.renderer.createText(this._el_20,'',(null as any));
    this._text_22 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this._el_23 = import4.createRenderElement(this.renderer,this._el_0,'td',new import4.InlineArray2(2,'class','product-quantity'),(null as any));
    this._text_24 = this.renderer.createText(this._el_23,'\n                                ',(null as any));
    this._el_25 = import4.createRenderElement(this.renderer,this._el_23,'div',new import4.InlineArray2(2,'class','select-style med-input shop-shorting shop-shorting-cart no-border-round'),(null as any));
    this._text_26 = this.renderer.createText(this._el_25,'\n                                    ',(null as any));
    this._el_27 = import4.createRenderElement(this.renderer,this._el_25,'select',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._SelectControlValueAccessor_27_3 = new import27.Wrapper_SelectControlValueAccessor(this.renderer,new import11.ElementRef(this._el_27));
    this._NG_VALUE_ACCESSOR_27_4 = [this._SelectControlValueAccessor_27_3.context];
    this._NgModel_27_5 = new import28.Wrapper_NgModel((null as any),(null as any),(null as any),this._NG_VALUE_ACCESSOR_27_4);
    this._NgControl_27_6 = this._NgModel_27_5.context;
    this._NgControlStatus_27_7 = new import29.Wrapper_NgControlStatus(this._NgControl_27_6);
    this._text_28 = this.renderer.createText(this._el_27,'\n                                        ',(null as any));
    this._anchor_29 = this.renderer.createTemplateAnchor(this._el_27,(null as any));
    this._appEl_29 = new import3.AppElement(29,27,this,this._anchor_29);
    this._TemplateRef_29_5 = new import21.TemplateRef_(this._appEl_29,viewFactory_CartComponent8);
    this._NgFor_29_6 = new import24.Wrapper_NgFor(this._appEl_29.vcRef,this._TemplateRef_29_5,this.parent.parent.parent.parentInjector.get(import25.IterableDiffers),this.parent.parent.parent.ref);
    this._text_30 = this.renderer.createText(this._el_27,'\n                                    ',(null as any));
    this._text_31 = this.renderer.createText(this._el_25,'\n                                ',(null as any));
    this._text_32 = this.renderer.createText(this._el_23,'\n                            ',(null as any));
    this._text_33 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this._el_34 = import4.createRenderElement(this.renderer,this._el_0,'td',new import4.InlineArray2(2,'class','product-subtotal text-left'),(null as any));
    this._text_35 = this.renderer.createText(this._el_34,'',(null as any));
    this._text_36 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this._el_37 = import4.createRenderElement(this.renderer,this._el_0,'td',new import4.InlineArray2(2,'class','product-remove text-center'),(null as any));
    this._text_38 = this.renderer.createText(this._el_37,'\n                                ',(null as any));
    this._el_39 = import4.createRenderElement(this.renderer,this._el_37,'a',new import4.InlineArray2(2,'class','pointer'),(null as any));
    this._el_40 = import4.createRenderElement(this.renderer,this._el_39,'i',new import4.InlineArray2(2,'class','fa fa-times'),(null as any));
    this._text_41 = this.renderer.createText(this._el_37,'\n                            ',(null as any));
    this._text_42 = this.renderer.createText(this._el_0,'\n                        ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_4,'click',this.eventHandler(this._handle_click_4_0.bind(this)));
    var disposable_1:Function = this.renderer.listen(this._el_12,'click',this.eventHandler(this._handle_click_12_0.bind(this)));
    this._pipe_numberFormat_1_0 = import4.pureProxy2((<_View_CartComponent0>this.parent.parent.parent)._pipe_numberFormat_1.transform.bind((<_View_CartComponent0>this.parent.parent.parent)._pipe_numberFormat_1));
    var disposable_2:Function = this.renderer.listen(this._el_27,'ngModelChange',this.eventHandler(this._handle_ngModelChange_27_0.bind(this)));
    var disposable_3:Function = this.renderer.listen(this._el_27,'change',this.eventHandler(this._handle_change_27_1.bind(this)));
    var disposable_4:Function = this.renderer.listen(this._el_27,'blur',this.eventHandler(this._handle_blur_27_2.bind(this)));
    const subscription_0:any = this._NgModel_27_5.context.update.subscribe(this.eventHandler(this._handle_ngModelChange_27_0.bind(this)));
    this._pipe_numberFormat_1_1 = import4.pureProxy2((<_View_CartComponent0>this.parent.parent.parent)._pipe_numberFormat_1.transform.bind((<_View_CartComponent0>this.parent.parent.parent)._pipe_numberFormat_1));
    var disposable_5:Function = this.renderer.listen(this._el_39,'click',this.eventHandler(this._handle_click_39_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._text_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._text_17,
      this._text_18,
      this._text_19,
      this._el_20,
      this._text_21,
      this._text_22,
      this._el_23,
      this._text_24,
      this._el_25,
      this._text_26,
      this._el_27,
      this._text_28,
      this._anchor_29,
      this._text_30,
      this._text_31,
      this._text_32,
      this._text_33,
      this._el_34,
      this._text_35,
      this._text_36,
      this._el_37,
      this._text_38,
      this._el_39,
      this._el_40,
      this._text_41,
      this._text_42
    ]
    ,[
      disposable_0,
      disposable_1,
      disposable_2,
      disposable_3,
      disposable_4,
      disposable_5
    ]
    ,[subscription_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import21.TemplateRef) && (29 === requestNodeIndex))) { return this._TemplateRef_29_5; }
    if (((token === import26.NgFor) && (29 === requestNodeIndex))) { return this._NgFor_29_6.context; }
    if (((token === import30.SelectControlValueAccessor) && ((27 <= requestNodeIndex) && (requestNodeIndex <= 30)))) { return this._SelectControlValueAccessor_27_3.context; }
    if (((token === import31.NG_VALUE_ACCESSOR) && ((27 <= requestNodeIndex) && (requestNodeIndex <= 30)))) { return this._NG_VALUE_ACCESSOR_27_4; }
    if (((token === import32.NgModel) && ((27 <= requestNodeIndex) && (requestNodeIndex <= 30)))) { return this._NgModel_27_5.context; }
    if (((token === import33.NgControl) && ((27 <= requestNodeIndex) && (requestNodeIndex <= 30)))) { return this._NgControl_27_6; }
    if (((token === import34.NgControlStatus) && ((27 <= requestNodeIndex) && (requestNodeIndex <= 30)))) { return this._NgControlStatus_27_7.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import7.ValueUnwrapper();
    this._SelectControlValueAccessor_27_3.detectChangesInInputProps(this,this._el_27,throwOnChange);
    const currVal_27_1_0:any = this.context.$implicit.qty;
    this._NgModel_27_5.check_model(currVal_27_1_0,throwOnChange,false);
    this._NgModel_27_5.detectChangesInInputProps(this,this._el_27,throwOnChange);
    this._NgControlStatus_27_7.detectChangesInInputProps(this,this._el_27,throwOnChange);
    const currVal_29_0_0:any = this._arr_56(1,2,3,4,5,6,7,8,9,10);
    this._NgFor_29_6.check_ngForOf(currVal_29_0_0,throwOnChange,false);
    this._NgFor_29_6.detectChangesInInputProps(this,this._anchor_29,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    const currVal_51:any = import4.interpolate(1,'/data/covers/',this.context.$implicit.content.cover.front,'');
    if (import4.checkBinding(throwOnChange,this._expr_51,currVal_51)) {
      this.renderer.setElementProperty(this._el_6,'src',this.viewUtils.sanitizer.sanitize(import23.SecurityContext.URL,currVal_51));
      this._expr_51 = currVal_51;
    }
    const currVal_52:any = import4.interpolate(1,'',this.context.$implicit.content.title,'');
    if (import4.checkBinding(throwOnChange,this._expr_52,currVal_52)) {
      this.renderer.setText(this._text_13,currVal_52);
      this._expr_52 = currVal_52;
    }
    const currVal_53:any = import4.interpolate(1,'Ref: ',this.context.$implicit.content.reference,'');
    if (import4.checkBinding(throwOnChange,this._expr_53,currVal_53)) {
      this.renderer.setText(this._text_16,currVal_53);
      this._expr_53 = currVal_53;
    }
    valUnwrapper.reset();
    const currVal_54:any = import4.interpolate(1,'\n                                ',valUnwrapper.unwrap(import4.castByValue(this._pipe_numberFormat_1_0,(<_View_CartComponent0>this.parent.parent.parent)._pipe_numberFormat_1.transform)(this.context.$implicit.content.price,2)),'€\n                            ');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_54,currVal_54))) {
      this.renderer.setText(this._text_21,currVal_54);
      this._expr_54 = currVal_54;
    }
    this._SelectControlValueAccessor_27_3.detectChangesInHostProps(this,this._el_27,throwOnChange);
    this._NgModel_27_5.detectChangesInHostProps(this,this._el_27,throwOnChange);
    this._NgControlStatus_27_7.detectChangesInHostProps(this,this._el_27,throwOnChange);
    valUnwrapper.reset();
    const currVal_57:any = import4.interpolate(1,'\n                                ',valUnwrapper.unwrap(import4.castByValue(this._pipe_numberFormat_1_1,(<_View_CartComponent0>this.parent.parent.parent)._pipe_numberFormat_1.transform)((this.context.$implicit.qty * this.context.$implicit.content.price),2)),'€');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_57,currVal_57))) {
      this.renderer.setText(this._text_35,currVal_57);
      this._expr_57 = currVal_57;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  destroyInternal():void {
    this._NgModel_27_5.context.ngOnDestroy();
  }
  private _handle_click_4_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_4_0:any = ((<any>this.parent.parent.parent.context.router.navigate([this.context.$implicit.content.url],{relativeTo: this.parent.parent.parent.context.route.parent})) !== false);
    return (true && pd_4_0);
  }
  private _handle_click_12_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_12_0:any = ((<any>this.parent.parent.parent.context.router.navigate([this.context.$implicit.content.url],{relativeTo: this.parent.parent.parent.context.route.parent})) !== false);
    return (true && pd_12_0);
  }
  private _handle_ngModelChange_27_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_27_0:any = ((<any>(this.context.$implicit.qty = $event)) !== false);
    return (true && pd_27_0);
  }
  private _handle_change_27_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_27_0:any = ((<any>this.parent.parent.parent.context.cartService.update(this.context.$implicit.content,$event.target.value)) !== false);
    const pd_27_1:any = ((<any>this._SelectControlValueAccessor_27_3.context.onChange($event.target.value)) !== false);
    return ((true && pd_27_0) && pd_27_1);
  }
  private _handle_blur_27_2($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_27_0:any = ((<any>this._SelectControlValueAccessor_27_3.context.onTouched()) !== false);
    return (true && pd_27_0);
  }
  private _handle_click_39_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_39_0:any = ((<any>this.parent.parent.parent.context.cartService.remove(this.context.$implicit.content._id)) !== false);
    return (true && pd_39_0);
  }
}
function viewFactory_CartComponent7(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_CartComponent7(viewUtils,parentInjector,declarationEl);
}
class _View_CartComponent8 extends import1.AppView<any> {
  _el_0:any;
  _NgSelectOption_0_3:import27.Wrapper_NgSelectOption;
  _NgSelectMultipleOption_0_4:import35.Wrapper_NgSelectMultipleOption;
  _text_1:any;
  /*private*/ _expr_4:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_CartComponent8,renderType_CartComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_4 = import7.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'option',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._NgSelectOption_0_3 = new import27.Wrapper_NgSelectOption(new import11.ElementRef(this._el_0),this.renderer,(<_View_CartComponent7>this.parent)._SelectControlValueAccessor_27_3.context);
    this._NgSelectMultipleOption_0_4 = new import35.Wrapper_NgSelectMultipleOption(new import11.ElementRef(this._el_0),this.renderer,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import30.NgSelectOption) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._NgSelectOption_0_3.context; }
    if (((token === import36.NgSelectMultipleOption) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._NgSelectMultipleOption_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = this.context.$implicit;
    this._NgSelectOption_0_3.check_value(currVal_0_0_0,throwOnChange,false);
    this._NgSelectOption_0_3.detectChangesInInputProps(this,this._el_0,throwOnChange);
    const currVal_0_1_0:any = this.context.$implicit;
    this._NgSelectMultipleOption_0_4.check_value(currVal_0_1_0,throwOnChange,false);
    this._NgSelectMultipleOption_0_4.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._NgSelectOption_0_3.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this._NgSelectMultipleOption_0_4.detectChangesInHostProps(this,this._el_0,throwOnChange);
    const currVal_4:any = import4.interpolate(1,'',this.context.$implicit,'');
    if (import4.checkBinding(throwOnChange,this._expr_4,currVal_4)) {
      this.renderer.setText(this._text_1,currVal_4);
      this._expr_4 = currVal_4;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  destroyInternal():void {
    this._NgSelectOption_0_3.context.ngOnDestroy();
    this._NgSelectMultipleOption_0_4.context.ngOnDestroy();
  }
}
function viewFactory_CartComponent8(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_CartComponent8(viewUtils,parentInjector,declarationEl);
}
class _View_CartComponent9 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  /*private*/ _expr_5:any;
  _pipe_intl_0_8:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_CartComponent9,renderType_CartComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_5 = import7.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'div',new import4.InlineArray2(2,'class','col-sm-12 shop-cart-table'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_2 = import4.createRenderElement(this.renderer,this._el_0,'p',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._pipe_intl_0_8 = import4.pureProxy2((<_View_CartComponent0>this.parent.parent)._pipe_intl_0.transform.bind((<_View_CartComponent0>this.parent.parent)._pipe_intl_0));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import7.ValueUnwrapper();
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_5:any = import4.interpolate(1,'',valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_8,(<_View_CartComponent0>this.parent.parent)._pipe_intl_0.transform)(((this.parent.parent.context.intl.data == (null as any))? (null as any): this.parent.parent.context.intl.data.CART.EMPTY),this.parent.parent.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_5,currVal_5))) {
      this.renderer.setText(this._text_3,currVal_5);
      this._expr_5 = currVal_5;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_CartComponent9(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_CartComponent9(viewUtils,parentInjector,declarationEl);
}
class _View_CartComponent10 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  _pipe_intl_0_9:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_CartComponent10,renderType_CartComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_2 = import7.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'button',new import4.InlineArray2(2,'class','highlight-button btn btn-very-small no-margin pull-left'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_0,'click',this.eventHandler(this._handle_click_0_0.bind(this)));
    this._pipe_intl_0_9 = import4.pureProxy2((<_View_CartComponent0>this.parent.parent)._pipe_intl_0.transform.bind((<_View_CartComponent0>this.parent.parent)._pipe_intl_0));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1
    ]
    ,[disposable_0],([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import7.ValueUnwrapper();
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_2:any = import4.interpolate(1,'\n                    ',valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_9,(<_View_CartComponent0>this.parent.parent)._pipe_intl_0.transform)(((this.parent.parent.context.intl.data == (null as any))? (null as any): this.parent.parent.context.intl.data.CART.DO_EMPTY),this.parent.parent.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_2,currVal_2))) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_click_0_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_0_0:any = ((<any>this.parent.parent.context.cartService.clear()) !== false);
    return (true && pd_0_0);
  }
}
function viewFactory_CartComponent10(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_CartComponent10(viewUtils,parentInjector,declarationEl);
}
class _View_CartComponent11 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _text_2:any;
  _el_3:any;
  _text_4:any;
  _el_5:any;
  _text_6:any;
  _el_7:any;
  _text_8:any;
  _el_9:any;
  _text_10:any;
  _el_11:any;
  _text_12:any;
  _text_13:any;
  _el_14:any;
  _text_15:any;
  _text_16:any;
  _text_17:any;
  _el_18:any;
  _text_19:any;
  _el_20:any;
  _text_21:any;
  _el_22:any;
  _text_23:any;
  _el_24:any;
  _text_25:any;
  _el_26:any;
  _text_27:any;
  _el_28:any;
  _text_29:any;
  _text_30:any;
  _text_31:any;
  _el_32:any;
  _text_33:any;
  _text_34:any;
  _text_35:any;
  _el_36:any;
  _text_37:any;
  _el_38:any;
  _text_39:any;
  _el_40:any;
  _text_41:any;
  _text_42:any;
  _text_43:any;
  _el_44:any;
  _text_45:any;
  _el_46:any;
  _text_47:any;
  _text_48:any;
  _el_49:any;
  _text_50:any;
  _text_51:any;
  _text_52:any;
  _el_53:any;
  _text_54:any;
  _el_55:any;
  _text_56:any;
  _el_57:any;
  _text_58:any;
  _text_59:any;
  _text_60:any;
  _text_61:any;
  _text_62:any;
  _text_63:any;
  _text_64:any;
  _anchor_65:any;
  /*private*/ _appEl_65:import3.AppElement;
  _TemplateRef_65_5:any;
  _NgIf_65_6:import18.Wrapper_NgIf;
  _text_66:any;
  _el_67:any;
  /*private*/ _appEl_67:import3.AppElement;
  _PaymentPayPalExpressCheckoutComponent_67_4:import37.Wrapper_PaymentPayPalExpressCheckoutComponent;
  _text_68:any;
  _text_69:any;
  /*private*/ _expr_75:any;
  _pipe_intl_0_11:any;
  /*private*/ _expr_77:any;
  _pipe_numberFormat_1_2:any;
  /*private*/ _expr_79:any;
  _pipe_intl_0_12:any;
  /*private*/ _expr_81:any;
  _pipe_intl_0_13:any;
  /*private*/ _expr_83:any;
  _pipe_intl_0_14:any;
  /*private*/ _expr_85:any;
  _pipe_numberFormat_1_3:any;
  /*private*/ _expr_87:any;
  _pipe_intl_0_15:any;
  /*private*/ _expr_89:any;
  _pipe_numberFormat_1_4:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_CartComponent11,renderType_CartComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_75 = import7.UNINITIALIZED;
    this._expr_77 = import7.UNINITIALIZED;
    this._expr_79 = import7.UNINITIALIZED;
    this._expr_81 = import7.UNINITIALIZED;
    this._expr_83 = import7.UNINITIALIZED;
    this._expr_85 = import7.UNINITIALIZED;
    this._expr_87 = import7.UNINITIALIZED;
    this._expr_89 = import7.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'div',new import4.InlineArray2(2,'class','col-sm-12 padding-five no-padding-bottom'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n\n                ',(null as any));
    this._text_2 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_3 = import4.createRenderElement(this.renderer,this._el_0,'div',new import4.InlineArray2(2,'class','col-md-11 no-padding-right xs-no-padding'),(null as any));
    this._text_4 = this.renderer.createText(this._el_3,'\n                    ',(null as any));
    this._el_5 = import4.createRenderElement(this.renderer,this._el_3,'table',new import4.InlineArray2(2,'class','table cart-total'),(null as any));
    this._text_6 = this.renderer.createText(this._el_5,'\n                        ',(null as any));
    this._el_7 = import4.createRenderElement(this.renderer,this._el_5,'tbody',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_8 = this.renderer.createText(this._el_7,'\n                            ',(null as any));
    this._el_9 = import4.createRenderElement(this.renderer,this._el_7,'tr',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_10 = this.renderer.createText(this._el_9,'\n                                ',(null as any));
    this._el_11 = import4.createRenderElement(this.renderer,this._el_9,'th',new import4.InlineArray2(2,'class','padding-two text-right no-padding-right text-uppercase font-weight-600 letter-spacing-2 text-small xs-no-padding'),(null as any));
    this._text_12 = this.renderer.createText(this._el_11,'',(null as any));
    this._text_13 = this.renderer.createText(this._el_9,'\n                                ',(null as any));
    this._el_14 = import4.createRenderElement(this.renderer,this._el_9,'td',new import4.InlineArray2(2,'class','padding-two text-uppercase text-right no-padding-right font-weight-600 black-text xs-no-padding'),(null as any));
    this._text_15 = this.renderer.createText(this._el_14,'',(null as any));
    this._text_16 = this.renderer.createText(this._el_9,'\n                            ',(null as any));
    this._text_17 = this.renderer.createText(this._el_7,'\n                            ',(null as any));
    this._el_18 = import4.createRenderElement(this.renderer,this._el_7,'tr',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_19 = this.renderer.createText(this._el_18,'\n                                ',(null as any));
    this._el_20 = import4.createRenderElement(this.renderer,this._el_18,'th',new import4.InlineArray2(2,'class','padding-two text-right no-padding-right text-small xs-no-padding'),(null as any));
    this._text_21 = this.renderer.createText(this._el_20,'\n                                    ',(null as any));
    this._el_22 = import4.createRenderElement(this.renderer,this._el_20,'span',new import4.InlineArray2(2,'class','text-uppercase font-weight-600 letter-spacing-2'),(null as any));
    this._text_23 = this.renderer.createText(this._el_22,'',(null as any));
    this._el_24 = import4.createRenderElement(this.renderer,this._el_20,'br',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_25 = this.renderer.createText(this._el_20,'\n                                    ',(null as any));
    this._el_26 = import4.createRenderElement(this.renderer,this._el_20,'p',new import4.InlineArray2(2,'class','font-weight-100'),(null as any));
    this._text_27 = this.renderer.createText(this._el_26,'',(null as any));
    this._el_28 = import4.createRenderElement(this.renderer,this._el_26,'br',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_29 = this.renderer.createText(this._el_26,'',(null as any));
    this._text_30 = this.renderer.createText(this._el_20,'\n                                ',(null as any));
    this._text_31 = this.renderer.createText(this._el_18,'\n                                ',(null as any));
    this._el_32 = import4.createRenderElement(this.renderer,this._el_18,'td',new import4.InlineArray2(2,'class','padding-two text-uppercase text-right no-padding-right font-weight-600 black-text text-small xs-no-padding'),(null as any));
    this._text_33 = this.renderer.createText(this._el_32,'',(null as any));
    this._text_34 = this.renderer.createText(this._el_18,'\n                            ',(null as any));
    this._text_35 = this.renderer.createText(this._el_7,'\n                            ',(null as any));
    this._el_36 = import4.createRenderElement(this.renderer,this._el_7,'tr',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_37 = this.renderer.createText(this._el_36,'\n                                ',(null as any));
    this._el_38 = import4.createRenderElement(this.renderer,this._el_36,'td',new import4.InlineArray4(4,'class','padding-one no-padding-right xs-no-padding','colspan','2'),(null as any));
    this._text_39 = this.renderer.createText(this._el_38,'\n                                    ',(null as any));
    this._el_40 = import4.createRenderElement(this.renderer,this._el_38,'hr',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_41 = this.renderer.createText(this._el_38,'\n                                ',(null as any));
    this._text_42 = this.renderer.createText(this._el_36,'\n                            ',(null as any));
    this._text_43 = this.renderer.createText(this._el_7,'\n                            ',(null as any));
    this._el_44 = import4.createRenderElement(this.renderer,this._el_7,'tr',new import4.InlineArray2(2,'class','total'),(null as any));
    this._text_45 = this.renderer.createText(this._el_44,'\n                                ',(null as any));
    this._el_46 = import4.createRenderElement(this.renderer,this._el_44,'th',new import4.InlineArray2(2,'class','padding-two text-uppercase text-right no-padding-right font-weight-600 text-large xs-no-padding'),(null as any));
    this._text_47 = this.renderer.createText(this._el_46,'',(null as any));
    this._text_48 = this.renderer.createText(this._el_44,'\n                                ',(null as any));
    this._el_49 = import4.createRenderElement(this.renderer,this._el_44,'td',new import4.InlineArray2(2,'class','padding-two text-uppercase text-right no-padding-right font-weight-600 black-text text-large no-letter-spacing xs-no-padding'),(null as any));
    this._text_50 = this.renderer.createText(this._el_49,'',(null as any));
    this._text_51 = this.renderer.createText(this._el_44,'\n                            ',(null as any));
    this._text_52 = this.renderer.createText(this._el_7,'\n                            ',(null as any));
    this._el_53 = import4.createRenderElement(this.renderer,this._el_7,'tr',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_54 = this.renderer.createText(this._el_53,'\n                                ',(null as any));
    this._el_55 = import4.createRenderElement(this.renderer,this._el_53,'td',new import4.InlineArray4(4,'class','padding-one no-padding-right xs-no-padding','colspan','2'),(null as any));
    this._text_56 = this.renderer.createText(this._el_55,'\n                                    ',(null as any));
    this._el_57 = import4.createRenderElement(this.renderer,this._el_55,'hr',new import4.InlineArray2(2,'class','no-margin-bottom'),(null as any));
    this._text_58 = this.renderer.createText(this._el_55,'\n                                ',(null as any));
    this._text_59 = this.renderer.createText(this._el_53,'\n                            ',(null as any));
    this._text_60 = this.renderer.createText(this._el_7,'\n                        ',(null as any));
    this._text_61 = this.renderer.createText(this._el_5,'\n                    ',(null as any));
    this._text_62 = this.renderer.createText(this._el_3,'\n                    ',(null as any));
    this._text_63 = this.renderer.createText(this._el_3,'\n\n                ',(null as any));
    this._text_64 = this.renderer.createText(this._el_0,'\n\n                ',(null as any));
    this._anchor_65 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._appEl_65 = new import3.AppElement(65,0,this,this._anchor_65);
    this._TemplateRef_65_5 = new import21.TemplateRef_(this._appEl_65,viewFactory_CartComponent12);
    this._NgIf_65_6 = new import18.Wrapper_NgIf(this._appEl_65.vcRef,this._TemplateRef_65_5);
    this._text_66 = this.renderer.createText(this._el_0,'\n\n                ',(null as any));
    this._el_67 = import4.createRenderElement(this.renderer,this._el_0,'payment-paypal-express-checkout',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._appEl_67 = new import3.AppElement(67,0,this,this._el_67);
    var compView_67:any = import37.viewFactory_PaymentPayPalExpressCheckoutComponent0(this.viewUtils,this.injector(67),this._appEl_67);
    this._PaymentPayPalExpressCheckoutComponent_67_4 = new import37.Wrapper_PaymentPayPalExpressCheckoutComponent(this.parent.parent.parentInjector.get(import13.CartService),this.parent.parent.parentInjector.get(import12.UtilsService),this.parent.parent.parentInjector.get(import9.ConfigService));
    this._appEl_67.initComponent(this._PaymentPayPalExpressCheckoutComponent_67_4.context,([] as any[]),compView_67);
    compView_67.create(this._PaymentPayPalExpressCheckoutComponent_67_4.context,([] as any[]),(null as any));
    this._text_68 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._text_69 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._pipe_intl_0_11 = import4.pureProxy2((<_View_CartComponent0>this.parent.parent)._pipe_intl_0.transform.bind((<_View_CartComponent0>this.parent.parent)._pipe_intl_0));
    this._pipe_numberFormat_1_2 = import4.pureProxy2((<_View_CartComponent0>this.parent.parent)._pipe_numberFormat_1.transform.bind((<_View_CartComponent0>this.parent.parent)._pipe_numberFormat_1));
    this._pipe_intl_0_12 = import4.pureProxy2((<_View_CartComponent0>this.parent.parent)._pipe_intl_0.transform.bind((<_View_CartComponent0>this.parent.parent)._pipe_intl_0));
    this._pipe_intl_0_13 = import4.pureProxy2((<_View_CartComponent0>this.parent.parent)._pipe_intl_0.transform.bind((<_View_CartComponent0>this.parent.parent)._pipe_intl_0));
    this._pipe_intl_0_14 = import4.pureProxy2((<_View_CartComponent0>this.parent.parent)._pipe_intl_0.transform.bind((<_View_CartComponent0>this.parent.parent)._pipe_intl_0));
    this._pipe_numberFormat_1_3 = import4.pureProxy2((<_View_CartComponent0>this.parent.parent)._pipe_numberFormat_1.transform.bind((<_View_CartComponent0>this.parent.parent)._pipe_numberFormat_1));
    this._pipe_intl_0_15 = import4.pureProxy2((<_View_CartComponent0>this.parent.parent)._pipe_intl_0.transform.bind((<_View_CartComponent0>this.parent.parent)._pipe_intl_0));
    this._pipe_numberFormat_1_4 = import4.pureProxy2((<_View_CartComponent0>this.parent.parent)._pipe_numberFormat_1.transform.bind((<_View_CartComponent0>this.parent.parent)._pipe_numberFormat_1));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._text_2,
      this._el_3,
      this._text_4,
      this._el_5,
      this._text_6,
      this._el_7,
      this._text_8,
      this._el_9,
      this._text_10,
      this._el_11,
      this._text_12,
      this._text_13,
      this._el_14,
      this._text_15,
      this._text_16,
      this._text_17,
      this._el_18,
      this._text_19,
      this._el_20,
      this._text_21,
      this._el_22,
      this._text_23,
      this._el_24,
      this._text_25,
      this._el_26,
      this._text_27,
      this._el_28,
      this._text_29,
      this._text_30,
      this._text_31,
      this._el_32,
      this._text_33,
      this._text_34,
      this._text_35,
      this._el_36,
      this._text_37,
      this._el_38,
      this._text_39,
      this._el_40,
      this._text_41,
      this._text_42,
      this._text_43,
      this._el_44,
      this._text_45,
      this._el_46,
      this._text_47,
      this._text_48,
      this._el_49,
      this._text_50,
      this._text_51,
      this._text_52,
      this._el_53,
      this._text_54,
      this._el_55,
      this._text_56,
      this._el_57,
      this._text_58,
      this._text_59,
      this._text_60,
      this._text_61,
      this._text_62,
      this._text_63,
      this._text_64,
      this._anchor_65,
      this._text_66,
      this._el_67,
      this._text_68,
      this._text_69
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import21.TemplateRef) && (65 === requestNodeIndex))) { return this._TemplateRef_65_5; }
    if (((token === import22.NgIf) && (65 === requestNodeIndex))) { return this._NgIf_65_6.context; }
    if (((token === import38.PaymentPayPalExpressCheckoutComponent) && (67 === requestNodeIndex))) { return this._PaymentPayPalExpressCheckoutComponent_67_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import7.ValueUnwrapper();
    const currVal_65_0_0:any = (this.parent.parent.context.awayMessage && this.parent.parent.context.awayMessage.active);
    this._NgIf_65_6.check_ngIf(currVal_65_0_0,throwOnChange,false);
    this._NgIf_65_6.detectChangesInInputProps(this,this._anchor_65,throwOnChange);
    const currVal_67_0_0:any = this.parent.parent.context.currentLanguage;
    this._PaymentPayPalExpressCheckoutComponent_67_4.check_language(currVal_67_0_0,throwOnChange,false);
    this._PaymentPayPalExpressCheckoutComponent_67_4.detectChangesInInputProps(this,this._el_67,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_75:any = import4.interpolate(1,'\n                                    ',valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_11,(<_View_CartComponent0>this.parent.parent)._pipe_intl_0.transform)(((this.parent.parent.context.intl.data == (null as any))? (null as any): this.parent.parent.context.intl.data.CART.PROPERTY.SUBTOTAL),this.parent.parent.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_75,currVal_75))) {
      this.renderer.setText(this._text_12,currVal_75);
      this._expr_75 = currVal_75;
    }
    valUnwrapper.reset();
    const currVal_77:any = import4.interpolate(1,'\n                                    ',valUnwrapper.unwrap(import4.castByValue(this._pipe_numberFormat_1_2,(<_View_CartComponent0>this.parent.parent)._pipe_numberFormat_1.transform)(this.parent.parent.context.cartService.subtotal(),2)),' €');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_77,currVal_77))) {
      this.renderer.setText(this._text_15,currVal_77);
      this._expr_77 = currVal_77;
    }
    valUnwrapper.reset();
    const currVal_79:any = import4.interpolate(1,'\n                                        ',valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_12,(<_View_CartComponent0>this.parent.parent)._pipe_intl_0.transform)(((this.parent.parent.context.intl.data == (null as any))? (null as any): this.parent.parent.context.intl.data.CART.PROPERTY.SHIPPING.TITLE),this.parent.parent.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_79,currVal_79))) {
      this.renderer.setText(this._text_23,currVal_79);
      this._expr_79 = currVal_79;
    }
    valUnwrapper.reset();
    const currVal_81:any = import4.interpolate(1,'\n                                        ',valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_13,(<_View_CartComponent0>this.parent.parent)._pipe_intl_0.transform)(((this.parent.parent.context.intl.data == (null as any))? (null as any): this.parent.parent.context.intl.data.CART.PROPERTY.SHIPPING.ONE),this.parent.parent.context.currentLanguage)),': 9.70 €');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_81,currVal_81))) {
      this.renderer.setText(this._text_27,currVal_81);
      this._expr_81 = currVal_81;
    }
    valUnwrapper.reset();
    const currVal_83:any = import4.interpolate(1,'\n                                        ',valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_14,(<_View_CartComponent0>this.parent.parent)._pipe_intl_0.transform)(((this.parent.parent.context.intl.data == (null as any))? (null as any): this.parent.parent.context.intl.data.CART.PROPERTY.SHIPPING.OTHERS),this.parent.parent.context.currentLanguage)),': 3.00 €');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_83,currVal_83))) {
      this.renderer.setText(this._text_29,currVal_83);
      this._expr_83 = currVal_83;
    }
    valUnwrapper.reset();
    const currVal_85:any = import4.interpolate(1,'\n                                    ',valUnwrapper.unwrap(import4.castByValue(this._pipe_numberFormat_1_3,(<_View_CartComponent0>this.parent.parent)._pipe_numberFormat_1.transform)(this.parent.parent.context.cartService.shipping(),2)),' €');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_85,currVal_85))) {
      this.renderer.setText(this._text_33,currVal_85);
      this._expr_85 = currVal_85;
    }
    valUnwrapper.reset();
    const currVal_87:any = import4.interpolate(1,'\n                                    ',valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_15,(<_View_CartComponent0>this.parent.parent)._pipe_intl_0.transform)(((this.parent.parent.context.intl.data == (null as any))? (null as any): this.parent.parent.context.intl.data.CART.PROPERTY.TOTAL),this.parent.parent.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_87,currVal_87))) {
      this.renderer.setText(this._text_47,currVal_87);
      this._expr_87 = currVal_87;
    }
    valUnwrapper.reset();
    const currVal_89:any = import4.interpolate(1,'\n                                    ',valUnwrapper.unwrap(import4.castByValue(this._pipe_numberFormat_1_4,(<_View_CartComponent0>this.parent.parent)._pipe_numberFormat_1.transform)(this.parent.parent.context.cartService.total(),2)),' €');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_89,currVal_89))) {
      this.renderer.setText(this._text_50,currVal_89);
      this._expr_89 = currVal_89;
    }
    this._PaymentPayPalExpressCheckoutComponent_67_4.detectChangesInHostProps(this,this._el_67,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_CartComponent11(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_CartComponent11(viewUtils,parentInjector,declarationEl);
}
class _View_CartComponent12 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _el_5:any;
  _text_6:any;
  /*private*/ _expr_7:any;
  /*private*/ _expr_8:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_CartComponent12,renderType_CartComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_7 = import7.UNINITIALIZED;
    this._expr_8 = import7.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'div',new import4.InlineArray2(2,'class','text-center col-md-12 block message-away'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_2 = import4.createRenderElement(this.renderer,this._el_0,'div',new import4.InlineArray2(2,'class','message-away-title'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,' \n                    ',(null as any));
    this._el_5 = import4.createRenderElement(this.renderer,this._el_0,'div',new import4.InlineArray2(2,'class','message-away-content'),(null as any));
    this._text_6 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._el_5,
      this._text_6
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this.detectContentChildrenChanges(throwOnChange);
    const currVal_7:any = import4.interpolate(1,'',this.parent.parent.parent.context.awayMessage.title[this.parent.parent.parent.context.currentLanguage],':');
    if (import4.checkBinding(throwOnChange,this._expr_7,currVal_7)) {
      this.renderer.setText(this._text_3,currVal_7);
      this._expr_7 = currVal_7;
    }
    const currVal_8:any = this.parent.parent.parent.context.awayMessage.content[this.parent.parent.parent.context.currentLanguage];
    if (import4.checkBinding(throwOnChange,this._expr_8,currVal_8)) {
      this.renderer.setElementProperty(this._el_5,'innerHTML',this.viewUtils.sanitizer.sanitize(import23.SecurityContext.HTML,currVal_8));
      this._expr_8 = currVal_8;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_CartComponent12(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_CartComponent12(viewUtils,parentInjector,declarationEl);
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/front/cart.component.ngfactory.ts